import {
  BellOutlined,
  CloseCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Alert, Badge, Button, Popover, theme } from "antd";
import type { Notification } from "pages/api/[orgId]/notifications/types";
import {
  notificationContext,
  useNotificationContext,
  useNotifications,
} from "src/hooks/useNotifications";
import { Time } from "./Time";
import { Flex } from "./Flex";
import { TextTruncated } from "./TextTruncated";

export const Notifications = (props: { orgId: string }) => {
  const context = useNotifications({ orgId: props.orgId });
  return (
    <notificationContext.Provider value={context}>
      <NotificationComponent />
    </notificationContext.Provider>
  );
};

const NotificationComponent = () => {
  const { token } = theme.useToken();
  const { ready, notifications, dismiss } = useNotificationContext();

  if (!ready || notifications.length === 0)
    return (
      <Button type="text" shape="circle" size="small" disabled>
        <BellOutlined
          style={{ fontSize: 12, color: token.colorTextLightSolid }}
        />
      </Button>
    );

  return (
    <Popover
      align={{ offset: [0, 0] }}
      placement="rightBottom"
      content={
        <div style={{ maxWidth: "400px" }}>
          {notifications.map((notif) => (
            <NotificationItem key={notif.id} notif={notif} dismiss={dismiss} />
          ))}
        </div>
      }
    >
      <Button type="text" shape="circle" size="small">
        <Badge
          size="small"
          count={notifications.length}
          style={{ color: "white", fontSize: 9, padding: 1 }}
        >
          <BellOutlined
            style={{ fontSize: 12, color: token.colorTextLightSolid }}
          />
        </Badge>
      </Button>
    </Popover>
  );
};

const NotificationItem = (props: {
  notif: Notification;
  dismiss(id: Notification["id"]): Promise<void>;
}) => {
  const { token } = theme.useToken();
  if (props.notif.type === "IntegrationError") {
    return (
      <Alert
        className="notification"
        style={{ fontSize: "12px" }}
        message={
          <Flex>
            <div style={{ marginRight: "10px" }}>
              <WarningOutlined style={{ fontSize: "20px" }} />
            </div>
            <div>
              <TextTruncated lines={5}>
                <span style={{ textTransform: "capitalize" }}>
                  {props.notif.metadata.integration}
                </span>{" "}
                {`Integration Error: ${props.notif.message}`}
              </TextTruncated>
              <Time
                className="notification-timestamp"
                style={{ color: token.colorTextSecondary, fontSize: "10px" }}
                value={props.notif.updatedAt}
              />
            </div>
            {props.dismiss && (
              <div
                onClick={() => props.dismiss && props.dismiss(props.notif.id)}
              >
                <CloseCircleOutlined />
              </div>
            )}
          </Flex>
        }
        type="error"
      />
    );
  }
  return <Alert message={props.notif.message} type="info" showIcon />;
};
